module.exports = __webpack_public_path__ + "img/space-24.a0da1c22.svg";